<style lang="stylus" scoped>
    .rightclickmenu-aiflow
        >>>.ft-menu
            cursor pointer
            .ft-menutext
                font-size 14px
    .aiflow-gray-text
        width 100%
        height 32px
        display flex
        align-items center
        p
            padding-left 10px
            font-size 12px
            color rgba(34, 34, 34, 0.70)
        &.aiflow-h-divided
            border-top 1px solid rgba(0, 0, 0, 0.06)
</style>

<template>
    <div class="rightclickmenu-aiflow">
        <AIFloatMenuPictureAnalysis :fromType="'rightClickMenu'" />
        <div class="aiflow-gray-text" :class="{ 'aiflow-h-divided': !internal }">
            <p>{{ $t("AIFlow") }}</p>
        </div>
        <MenuList :menuList="aiFlowchartMenuList" @handleClicks="handleClicks(...arguments)" />
        <div class="aiflow-gray-text aiflow-h-divided" v-if="activeText">
            <p>{{ $t("AIText") }}</p>
        </div>
        <template v-if="activeText">
            <AiMenuList :isAIFlowChild="true"></AiMenuList>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import AiMenuList from "./AiMenuList.vue";
    import MenuList from "@/app/components/MenuList.vue";
    import { aiStatusType } from "@/app/components/ai3/enum";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";

    @Component({
        components: {
            AiMenuList,
            MenuList,
            AIFloatMenuPictureAnalysis,
        },
    })
    export default class AiFlow extends Vue {
        @Prop()
        from;
        get flowAnalyse() {
            return this.$store.state.shape.flowAnalyse;
        }
        get activeText() {
            return this.$store.state.shape.activeText;
        }
        get aiFlowchartMenuList() {
            return {
                list: this.internal
                    ? [
                          {
                              key: "flowPart",
                              label: this.$t("flowPart"),
                              img: "ai-flowchart-analyse",
                          },
                      ]
                    : [
                          {
                              key: "flowPart",
                              label: this.$t("flowPart"),
                              img: "ai-flowchart-analyse",
                          },
                          {
                              key: "flowImprove",
                              label: this.$t("flowImprove"),
                              img: "ai-flowchart-improve",
                          },
                          {
                              key: "flowDesc",
                              label: this.$t("flowDesc"),
                              img: "ai-flowchart-desc",
                          },
                      ],
            };
        }
        // ai3 协议
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        agree = false;
        readLocal() {
            let str = localStorage.getItem("ai3") || null;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj.agreement || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.user_id == list[i].user_id) {
                        exit = true;
                        this.agree = list[i].data;
                        break;
                    }
                }
                !exit && (this.agree = false);
            } else {
                this.agree = false;
            }
            return this.agree;
        }
        showAgreement() {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("showAgreement", true);
            });
        }
        handleClicks(...args) {
            this.$store.commit("closeContext");
            this.$emit("closeDrop"); // 兼容顶部栏关闭菜单
            if (this.agree || this.readLocal()) {
            } else {
                this.showAgreement();
                return;
            }
            const key = args[0];
            const clickEvents = new Map([
                [
                    "flowPart",
                    () => {
                        this.aiClickMenu(aiStatusType.flowchartAnalyse, this.$t("flowPart"));
                    },
                ],
                [
                    "flowDesc",
                    () => {
                        this.aiClickMenu(aiStatusType.flowchartExplain, this.$t("flowDesc"));
                    },
                ],
                [
                    "flowImprove",
                    () => {
                        this.aiClickMenu(aiStatusType.flowchartOptimize, this.$t("flowImprove"));
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        aiClickMenu(id, label) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("aiFlowAnalyse", id, label);
            });
            if (this.from == "topDrop") {
                this.aiTrackData(id);
            }
        }
        aiTrackData(id) {
            let obj = {
                [aiStatusType.flowchartAnalyse]: "Flowchart Analysis-Detection",
                [aiStatusType.flowchartExplain]: "Flowchart Analysis-Description",
                [aiStatusType.flowchartOptimize]: "Flowchart Analysis-Optimization",
            };
            this.sensors.track("clickAItoolbar", {
                Catalogues: "AI",
                click_type: obj[id],
            });
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "AIText": "文本分析",
        "AIFlow": "流程图分析",
        "flowPart": "流程图检测",
        "flowDesc": "流程图说明",
        "flowImprove": "流程图优化"
    },
    "en": {
        "AIText": "Text Analysis",
        "AIFlow": "Flowchart Analysis",
        "flowPart": "Flowchart Detection",
        "flowDesc": "Flowchart Description",
        "flowImprove": "Flowchart Optimization"
    },
    "fr": {
        "AIText": "Analyse de texte",
        "AIFlow": "Analyse d'organigramme",
        "flowPart": "Détection d'organigramme",
        "flowDesc": "Description d'organigramme",
        "flowImprove": "Optimisation d'organigramme"
    },
    "de": {
        "AIText": "Textanalyse",
        "AIFlow": "Flussdiagramm-Analyse",
        "flowPart": "Flussdiagramm-Erkennung",
        "flowDesc": "Flussdiagramm-Beschreibung",
        "flowImprove": "Flussdiagrammen-Optimierung"
    },
    "jp": {
        "AIText": "テキスト分析",
        "AIFlow": "フローチャートの分析",
        "flowPart": "フローチャートの検出",
        "flowDesc": "フローチャートの説明",
        "flowImprove": "フローチャートの最適化"
    },
    "es": {
        "AIText": "Análisis de texto",
        "AIFlow": "Análisis de diagrama de flujo",
        "flowPart": "Detección de diagrama de flujo",
        "flowDesc": "Descripción de diagrama de flujo",
        "flowImprove": "Optimización de diagrama de flujo"
    },
    "pt": {
        "AIText": "Análise de texto",
        "AIFlow": "Análise de fluxograma",
        "flowPart": "Detecção de fluxograma",
        "flowDesc": "Descrição do fluxograma",
        "flowImprove": "Otimização de fluxograma"
    },
    "it": {
        "AIText": "Analisi testo",
        "AIFlow": "Analisi diagramma di flusso",
        "flowPart": "Rilevamento diagramma di flusso",
        "flowDesc": "Descrizione diagramma di flusso",
        "flowImprove": "Ottimizzazione diagramma di flusso"
    },
    "tw": {
        "AIFlow": "流程圖分析",
        "flowPart": "流程圖偵測",
        "flowDesc": "流程圖說明",
        "flowImprove": "流程圖最佳化"
    }
}
</i18n>
